<div class="inline-flex text-sm font-bold uppercase">
  {{ reason() | subscriptionCancelReason | async }}
</div>
